/**
 * @fliisi/pollen — Typography
 *
 * Font families and size/weight/lineHeight presets.
 * Design spec calls for Varela Round (headings) + Nunito (body),
 * but we use Inter as the practical default until custom fonts are loaded.
 */
import { createFont } from 'tamagui'

// ─── Heading Font ────────────────────────────────────────────────────────
// Varela Round in spec — Inter Bold as stand-in

const systemFont = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'

export const headingFont = createFont({
  family: systemFont,
  size: {
    1: 12,
    2: 14,
    3: 16,
    4: 18,  // h3
    5: 22,  // h2
    6: 28,  // h1
    7: 34,
    8: 42,
  },
  lineHeight: {
    1: 16,
    2: 18,
    3: 22,
    4: 24,
    5: 28,
    6: 34,
    7: 40,
    8: 50,
  },
  weight: {
    4: '600',   // semibold default for headings
    5: '700',
    6: '700',
    7: '700',
    8: '800',
  },
  letterSpacing: {
    4: 0,
    5: 0,
    6: -0.5,
    7: -0.5,
    8: -0.5,
  },
})

// ─── Cursive Font ────────────────────────────────────────────────────────
// Playfair Display Bold Italic — used for section titles, decorative headings

export const cursiveFont = createFont({
  family: 'PlayfairDisplay_700Bold_Italic',
  size: {
    1: 12, 2: 14, 3: 16, 4: 18, 5: 22, 6: 28, 7: 34, 8: 42,
  },
  lineHeight: {
    1: 16, 2: 18, 3: 22, 4: 24, 5: 28, 6: 34, 7: 40, 8: 50,
  },
  weight: {
    4: '700', 5: '700', 6: '700', 7: '700', 8: '700',
  },
  letterSpacing: {
    4: 0, 5: 0, 6: -0.5, 7: -0.5, 8: -0.5,
  },
})

// ─── Body Font ───────────────────────────────────────────────────────────
// Nunito in spec — Inter as stand-in

export const bodyFont = createFont({
  family: systemFont,
  size: {
    1: 11,   // caption small
    2: 12,   // caption
    3: 14,   // body small
    4: 16,   // body
    5: 18,
    6: 20,
  },
  lineHeight: {
    1: 14,
    2: 16,
    3: 20,
    4: 24,
    5: 26,
    6: 28,
  },
  weight: {
    1: '400',
    2: '400',
    3: '400',
    4: '400',
    5: '500',
    6: '600',
  },
  letterSpacing: {
    1: 0.5,
    2: 0.25,
    3: 0,
    4: 0,
    5: 0,
    6: 0.5,
  },
})
